import { render } from "./product-add-to-cart.vue?vue&type=template&id=6b9f90dc&lang=pug"
import script from "./product-add-to-cart.vue?vue&type=script&lang=js"
export * from "./product-add-to-cart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__